(function () {
  'use strict';

  angular
    .module('crewExpiryLogReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('crewExpiryLogReport', {
        url: '/crew-expiry-log-report',
        views:{
          'crewExpiryLogReportView': {
            templateUrl: 'crew-expiry-log-report/views/crew-expiry-log-report.tpl.html',
            controller: 'CrewExpiryLogReportCtrl',
            controllerAs: 'crewExpiryLogReport'
          }}
      });
  }
}());
